import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMiljoRettelser as getMiljoRettelserAction } from "../../../../actions/miljoRettelserActions";
import { getMiljoRettelser } from "../../../../selectors/miljogebyrTilbakameldingerFraBybetjenter";
import { toNorwegianDatetime } from "../../../../utils/date";
import Table from "../../Tables/Table";

export default function TilbakemeldingerFraBybetjenterContainer({
  miljogebyrId,
}) {
  const miljoRettelser = useSelector(getMiljoRettelser);
  const dispatch = useDispatch();

  useEffect(() => {
    if (miljogebyrId) dispatch(getMiljoRettelserAction(miljogebyrId));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const renderRow = (miljoRettelse) => (
    <tr key={miljoRettelse.id}>
      <td>
        {miljoRettelse.rettelseDato &&
          toNorwegianDatetime(miljoRettelse.rettelseDato).format(
            "DD.MM.YYYY HH:mm",
          )}
      </td>
      <td>{miljoRettelse.tjenestenummer}</td>
      <td>{miljoRettelse.rettelse}</td>
      <td>{miljoRettelse.kommentar}</td>
    </tr>
  );

  return (
    <section>
      <div className="detalj-ileggelse-header-wrapper">
        <h2>Tilbakemelding</h2>
      </div>
      <div className="detalj-ileggelse-table-wrapper">
        <Table renderRow={renderRow} items={miljoRettelser}>
          <th>Dato</th>
          <th>Tjenestenummer</th>
          <th>Rettelse</th>
          <th>Kommentar</th>
        </Table>
      </div>
    </section>
  );
}

TilbakemeldingerFraBybetjenterContainer.propTypes = {
  miljogebyrId: PropTypes.string,
};
